import {
  WSButton,
  WSCard,
  WSElement,
  WSImage,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import AssurelyLogo from "../../../../../../assets/images/requirements/assurely-logo.svg";
import styles from "./styles.module.scss";
import { openInNewTab } from "../../../../../../shared/utils/openInNewTab";

const ASSURELY_URL =
  "https://client.assurely.com/broker/lead/signup/?utm_source=google&utm_medium=website&utm_campaign=crugroupcampaign&utm_id=crugroupcampaign&step=desc";

export const AssurelyWidget: React.FC = () => {
  return (
    <WSElement>
      <WSText.Paragraph weight="medium" color="gray700" mb="S">
        Need to purchase insurance?
      </WSText.Paragraph>
      <WSText.ParagraphSm weight="book" color="gray500" mb="L">
        Learn more about getting insured with our partners.
      </WSText.ParagraphSm>
      <WSCard className={styles.assurelyWidget}>
        <WSList gap="M">
          <WSImage
            src={AssurelyLogo}
            placeholder="Assurely Logo"
            width={115}
            height={28}
          />

          <WSText.ParagraphSm weight="book" color="gray500">
            Get comprehensive business insurance tailored to your needs in
            minutes with Assurely, where industry-leading coverage meets
            cost-effective pricing for Wingspan members.
          </WSText.ParagraphSm>

          <WSButton.Secondary
            onClick={() => openInNewTab(ASSURELY_URL)}
            rightIcon="open-tab"
          >
            Get insured now
          </WSButton.Secondary>
        </WSList>
      </WSCard>
    </WSElement>
  );
};
